import * as React from "react"
import { cn } from "../../lib/utils"

const RadioGroupContext = React.createContext(null)

const RadioGroup = React.forwardRef(({ className, value, onValueChange, name, children, ...props }, ref) => {
  const groupName = React.useMemo(() => name || `rg-${Math.random().toString(36).slice(2)}`, [name])
  const context = React.useMemo(() => ({ value, onValueChange, name: groupName }), [value, onValueChange, groupName])
  return (
    <div role="radiogroup" className={cn("", className)} ref={ref} {...props}>
      <RadioGroupContext.Provider value={context}>{children}</RadioGroupContext.Provider>
    </div>
  )
})
RadioGroup.displayName = "RadioGroup"

const RadioGroupItem = React.forwardRef(({ className, value, id, disabled, ...props }, ref) => {
  const ctx = React.useContext(RadioGroupContext)
  const checked = ctx?.value === value
  return (
    <label htmlFor={id} className="inline-flex items-center">
      <input
        id={id}
        ref={ref}
        type="radio"
        name={ctx?.name}
        value={value}
        checked={!!checked}
        onChange={() => ctx?.onValueChange && ctx.onValueChange(value)}
        disabled={disabled}
        className="sr-only"
        {...props}
      />
      <span
        aria-hidden
        className={cn(
          "relative inline-block h-[12px] w-[12px] rounded-full bg-transparent shrink-0",
          disabled && "opacity-50",
          className
        )}
        style={{ border: '1px solid #CD6D2C' }}
      >
        <span
          className={cn(
            "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[6px] w-[6px] rounded-full",
            checked ? "bg-[#cd6d2c]" : "bg-transparent"
          )}
        />
      </span>
    </label>
  )
})
RadioGroupItem.displayName = "RadioGroupItem"

export { RadioGroup, RadioGroupItem }